import { useContext } from 'react';
import { TabContext } from '../contexts/TabContext';

const useTab = () => 
{
    const context = useContext(TabContext);
    return context || null;
}

export default useTab;